import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "speachTranslationSettings"
};
const _hoisted_2 = {
  key: 0,
  class: "emptyState"
};
const _hoisted_3 = {
  class: "emptyTitle"
};
const _hoisted_4 = {
  class: "emptyMessage"
};
const _hoisted_5 = {
  class: "overviewCard"
};
const _hoisted_6 = {
  class: "overviewLeft"
};
const _hoisted_7 = {
  class: "overviewTitle"
};
const _hoisted_8 = {
  class: "kpiRow"
};
const _hoisted_9 = {
  class: "kpi"
};
const _hoisted_10 = {
  class: "kpiLabel"
};
const _hoisted_11 = {
  class: "kpiValue"
};
const _hoisted_12 = {
  class: "kpi"
};
const _hoisted_13 = {
  class: "kpiLabel"
};
const _hoisted_14 = {
  class: "kpiValue"
};
const _hoisted_15 = {
  class: "kpi"
};
const _hoisted_16 = {
  class: "kpiLabel"
};
const _hoisted_17 = {
  class: "kpiValue"
};
const _hoisted_18 = {
  class: "kpi"
};
const _hoisted_19 = {
  class: "kpiLabel"
};
const _hoisted_20 = {
  class: "kpiValue"
};
const _hoisted_21 = {
  class: "overviewRight"
};
const _hoisted_22 = {
  key: 0,
  class: "missingBanner"
};
const _hoisted_23 = {
  class: "bannerText"
};
const _hoisted_24 = {
  class: "selectorSection"
};
const _hoisted_25 = {
  class: "sectionTitle"
};
const _hoisted_26 = {
  class: "selectorRow"
};
const _hoisted_27 = {
  class: "languagesTable"
};
const _hoisted_28 = {
  class: "tableHead"
};
const _hoisted_29 = {
  class: "cell langCell"
};
const _hoisted_30 = {
  class: "cell toTranslateCell"
};
const _hoisted_31 = {
  class: "cell doneCell"
};
const _hoisted_32 = {
  class: "cell activeCell"
};
const _hoisted_33 = {
  class: "tableRow"
};
const _hoisted_34 = {
  class: "cell langCell"
};
const _hoisted_35 = {
  class: "langName"
};
const _hoisted_36 = {
  class: "langSubtitle"
};
const _hoisted_37 = {
  class: "cell langCell"
};
const _hoisted_38 = {
  class: "langName"
};
const _hoisted_39 = {
  class: "cell toTranslateCell"
};
const _hoisted_40 = {
  key: 0
};
const _hoisted_41 = {
  key: 1,
  class: "muted"
};
const _hoisted_42 = {
  class: "cell doneCell"
};
const _hoisted_43 = {
  class: "progressWrap"
};
const _hoisted_44 = {
  class: "progressBar"
};
const _hoisted_45 = {
  class: "progressLabel"
};
const _hoisted_46 = {
  class: "cell activeCell"
};
const _hoisted_47 = {
  class: "cell actionsCell"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_select_advanced = _resolveComponent("w-select-advanced");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_icon_button = _resolveComponent("icon-button");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  const _component_speach_manage_translations_modal = _resolveComponent("speach-manage-translations-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.originalLang && !_ctx.loadingData ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_icon, {
    icon: "translate-off",
    class: "emptyIcon"
  }), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('speachTranslation.settings.noDefaultLang.title')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('speachTranslation.settings.noDefaultLang.message')), 1)])) : _ctx.originalLang ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('speachTranslation.settings.overview')), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('speachTranslation.settings.additionalLanguages')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.allLanguages.length || '-'), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createTextVNode(_toDisplayString(_ctx.$t('speachTranslation.settings.active')) + " ", 1), _createVNode(_component_icon, {
    icon: "information-outline",
    class: "helpIcon",
    title: _ctx.$t('speachTranslation.settings.activeHelp')
  }, null, 8, ["title"])]), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.activeLanguages.length || '-'), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('speachTranslation.settings.toTranslate')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.totalMissing || '-'), 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('speachTranslation.settings.done')), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.allLanguages.length ? `${_ctx.totalDonePercent}%` : '-'), 1)])])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_standard_button, {
    class: "aiBtn",
    disabled: !_ctx.activeLanguages.length || _ctx.translating,
    loading: _ctx.translating,
    onAction: _ctx.onTranslateWithAI
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "translate",
      class: "btnLeftIcon"
    }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.settings.translateWithAI')), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onAction"]), _createVNode(_component_standard_button, {
    class: "editBtn",
    outlined: true,
    disabled: !_ctx.allLanguages.length || _ctx.loadingData,
    onAction: _ctx.openManageModal
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "pencil-outline",
      class: "btnLeftIcon"
    }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('speachTranslation.settings.editTranslations')), 1)]),
    _: 1
  }, 8, ["disabled", "onAction"])])]), _ctx.hasMissingTranslations ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_icon, {
    icon: "alert-outline",
    class: "bannerIcon"
  }), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('speachTranslation.settings.missingBanner')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('speachTranslation.settings.additionalLanguages')), 1), _createElementVNode("div", _hoisted_26, [_createVNode(_component_w_select_advanced, {
    class: "selector",
    placeholder: _ctx.$t('speachTranslation.settings.selectPlaceholder'),
    options: _ctx.languageDropdownOptions,
    value: _ctx.languageDropdownSelected,
    multiple: true,
    filterable: true,
    "collapse-tags": false,
    disabled: _ctx.translating,
    onChange: _ctx.onSelectionChange
  }, null, 8, ["placeholder", "options", "value", "disabled", "onChange"]), _createVNode(_component_standard_button, {
    class: "addBtn",
    outlined: true,
    label: _ctx.$t('speachTranslation.settings.addBtn'),
    disabled: !_ctx.canAdd,
    onAction: _ctx.onAddLanguages
  }, null, 8, ["label", "disabled", "onAction"])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('speachTranslation.settings.language')), 1), _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('speachTranslation.settings.toTranslate')), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('speachTranslation.settings.done')), 1), _createElementVNode("div", _hoisted_32, [_createTextVNode(_toDisplayString(_ctx.$t('speachTranslation.settings.active')) + " ", 1), _createVNode(_component_icon, {
    icon: "information-outline",
    class: "helpIcon",
    title: _ctx.$t('speachTranslation.settings.activeHelp')
  }, null, 8, ["title"])]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "cell actionsCell"
  }, null, -1))]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.labelFor(_ctx.originalLang)), 1), _createElementVNode("div", _hoisted_36, [_createVNode(_component_icon, {
    icon: "flag-outline",
    class: "subtitleIcon"
  }), _createTextVNode(_toDisplayString(_ctx.$t('speachTranslation.settings.defaultLanguage')), 1)])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "cell toTranslateCell muted"
  }, "-", -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "cell doneCell muted"
  }, "-", -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "cell activeCell muted"
  }, "-", -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "cell actionsCell"
  }, null, -1))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, lang => {
    return _openBlock(), _createElementBlock("div", {
      key: lang,
      class: "tableRow"
    }, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.labelFor(lang)), 1)]), _createElementVNode("div", _hoisted_39, [_ctx.perLangStats[lang]?.missing ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.perLangStats[lang].missing), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_41, "-"))]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", {
      class: "progressFill",
      style: _normalizeStyle({
        width: `${_ctx.perLangStats[lang]?.donePercent || 0}%`
      })
    }, null, 4)]), _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.perLangStats[lang]?.donePercent || 0) + "%", 1)])]), _createElementVNode("div", _hoisted_46, [_createVNode(_component_el_switch, {
      "model-value": _ctx.isActive(lang),
      disabled: _ctx.togglingLang === lang,
      onChange: v => _ctx.onToggleActive(lang, v)
    }, null, 8, ["model-value", "disabled", "onChange"])]), _createElementVNode("div", _hoisted_47, [_createVNode(_component_icon_button, {
      icon: "pencil-outline",
      disabled: _ctx.loadingData,
      onClick: $event => _ctx.openManageModalForLang(lang)
    }, null, 8, ["disabled", "onClick"]), _createVNode(_component_icon_button, {
      icon: "trash-can-outline",
      color: "danger",
      disabled: _ctx.loadingData || _ctx.deletingLang === lang,
      onClick: $event => _ctx.askDeleteLang(lang)
    }, null, 8, ["disabled", "onClick"])])]);
  }), 128))]), _ctx.deleteDialogVisible ? (_openBlock(), _createBlock(_component_confirm_dialog, {
    key: 1,
    visible: _ctx.deleteDialogVisible,
    title: _ctx.$t('speachTranslation.settings.deleteDialog.title'),
    message: _ctx.$t('speachTranslation.settings.deleteDialog.message', {
      lang: _ctx.labelFor(_ctx.pendingDeleteLang || '')
    }),
    "confirm-button-text": _ctx.$t('speachTranslation.settings.deleteDialog.confirm'),
    "cancel-button-text": _ctx.$t('speachTranslation.settings.deleteDialog.cancel'),
    "dialog-class": "deleteTranslationDialog",
    onOnCanceled: _ctx.cancelDelete,
    onOnDialogClose: _ctx.cancelDelete,
    onOnConfirmed: _ctx.confirmDelete
  }, null, 8, ["visible", "title", "message", "confirm-button-text", "cancel-button-text", "onOnCanceled", "onOnDialogClose", "onOnConfirmed"])) : _createCommentVNode("", true), _ctx.editModalVisible ? (_openBlock(), _createBlock(_component_speach_manage_translations_modal, {
    key: 2,
    visible: _ctx.editModalVisible,
    "speach-id": _ctx.speachId,
    "target-languages": _ctx.modalTargetLanguages,
    "original-lang": _ctx.originalLang,
    "official-languages": _ctx.officialLanguages,
    "transcript-enabled": _ctx.transcriptEnabled,
    "vision-enabled": _ctx.visionEnabled,
    onClose: _cache[0] || (_cache[0] = $event => _ctx.editModalVisible = false),
    onSaved: _ctx.onTranslationsSaved
  }, null, 8, ["visible", "speach-id", "target-languages", "original-lang", "official-languages", "transcript-enabled", "vision-enabled", "onSaved"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
}